import data from "./buy-a-car.json";
import LottiePlayer, { Props as LottiePlayerProps } from "../LottiePlayer";

type Props = Omit<LottiePlayerProps, "data">;

const BuyACarLottie = (props: Props) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <LottiePlayer animationData={data} {...props} />;
};

export default BuyACarLottie;
